import {Pipe, PipeTransform} from '@angular/core';
import {TableColumn} from '../interfaces/table-column';
import {DatePipe} from '@angular/common';
const dot = require('dot-object');

@Pipe({
  name: 'dataPropertyGetter',
})
export class DataPropertyGetterPipe implements PipeTransform {
  constructor(public datepipe: DatePipe) {}
  transform(object: any, tableColumn: TableColumn, ...args: unknown[]): unknown {
    let result = {};

    result = dot.dot(object);

    if (tableColumn.pipe == 'Date') {
      result[tableColumn.dataKey] = this.datepipe.transform(result[tableColumn.dataKey], 'dd MMM yyyy hh:mm:ss a');
    }

    return result[tableColumn.dataKey] != null ? result[tableColumn.dataKey] : '-';
  }
}
